import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';

const dataSource = [
  {
    year: "Январь-август 2023",
    amount: 1905076.5,
  },
  {
    year: "Январь-август 2024",
    amount: 2154208.2,
  },
];

const FullExport = () => {
  return (
    <div style={{ width: '30%', height: 300,}}>
      <h2>Общий экспорт (тыс. долларов)</h2>
      <h2>2023-2024, Январь-Август</h2>

      <ResponsiveContainer width="100%" height="80%">
        <BarChart data={dataSource} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="amount" fill="#82ca9d" name="Экспорт" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FullExport;
